import { createContext, useContext } from 'react';

import { EntityGridConfig } from './entity-grid-config';

const context = createContext<EntityGridConfig | null>(null);

export const EntityGridConfigProvider = context.Provider;

export const useEntityGridConfig = () => {
  const config = useContext(context);

  if (!config) {
    throw new Error(
      'useEntityGridConfig must be used within an EntityGridConfigProvider'
    );
  }

  return config;
};
